import { Trans, useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import styled from 'styled-components'

import { Page } from '../components/Page'
import { GetStarted } from '../components/GetStarted'
import { Section } from '../components/Section'
import { H1 } from '../components/H1'
import { H2 } from '../components/H2'
import { P } from '../components/P'

// Documentation Page.
const DocumentationPage = () => {
  const { t } = useTranslation('common')
  return (
    <Page>
      <Section>
        <Div>
          <H1>{t(`Documentation`, `Documentation`)}</H1>
          <H2>{t(`Installation`, `Installation`)}</H2>
          <P>
            {t(
              `documentation807976632`,
              `The instructions to authorise using your Zoom account with Klyk WebApp:`,
            )}
          </P>
          <ol type="1">
            <li>
              <P>
                {t(`documentation2040194977`, `Login to your Klyk account`)}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation1516587523`,
                  `Click the button "Create event"`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1854418612`,
                  `Click the button "Authorise Zoom" to authorise your Zoom account`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1049855023`,
                  `You will be redirected to Zoom login page`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation632966266`,
                  `Login successful to your zoom account will direct you back to create event page`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1403338719`,
                  `Fill all the required fields and click "save and create an event"`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1674899313`,
                  `An event with a Zoom meeting link will be created`,
                )}
              </P>
            </li>
          </ol>

          <H2>{t(`Usage`, `Usage`)}</H2>
          <P>
            {t(
              `documentation-745215775`,
              `Create Event with a Zoom Meeting link. Use-Case Description of this feature/action:`,
            )}
          </P>
          <ol type="1">
            <li>
              <P>
                {t(`documentation2040194977`, `Login to your Klyk account`)}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation1516587523`,
                  `Click the button "Create event"`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1854418612`,
                  `Click the button "Authorise Zoom" to authorise your Zoom account`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1049855023`,
                  `You will be redirected to Zoom login page`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation632966266`,
                  `Login successful to your zoom account will direct you back to create event page`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1403338719`,
                  `Fill all the required fields and click "save and create an event"`,
                )}
              </P>
            </li>
            <li>
              <P>
                {t(
                  `documentation-1674899313`,
                  `An event with a Zoom meeting link will be created`,
                )}
              </P>
            </li>
          </ol>

          <H2>{t(`Uninstallation`, `Uninstallation`)}</H2>
          <P>
            {t(
              `documentation-662818648`,
              `Uninstalling Klyk WebApp from Zoom Marketplace:`,
            )}
          </P>
          <ol type="1">
            <li>
              <P>
                {t(
                  `documentation1271145990`,
                  `Login to your Zoom account and navigate to the Zoom App Marketplace`,
                )}
              </P>
            </li>
            <li>
              <P>
                <Trans i18nKey="documentation-898370494">
                  Click <strong>Manage &gt; Installed Apps</strong>
                </Trans>
              </P>
            </li>
            <li>
              <P>
                <Trans i18nKey="documentation-885894895">
                  Click the <strong>Klyk</strong> app
                </Trans>
              </P>
            </li>
            <li>
              <P>
                <Trans i18nKey="documentation-uninstall-app">
                  Click <strong>Uninstall</strong>
                </Trans>
              </P>
            </li>
          </ol>

          <H2>{t(`FAQ`, `FAQ`)}</H2>
          <P>
            <Trans i18nKey="documentation1623879233">
              For more information, please see our{' '}
              <a href="https://www.ourklyk.com/support">Support Page</a>.
            </Trans>
          </P>

          <H2>{t(`Contact Support`, `Contact Support`)}</H2>
          <P>
            {t(
              `documentation-2037817490`,
              `Thank you for taking the time to read our documentation page. If you have any questions regarding our documentation, you can reach our support team at admin@ourklyk.com.`,
            )}
            <P>
              <Trans i18nKey="documentation1623879233">
                For more information, please see our{' '}
                <a href="https://www.ourklyk.com/support">Support Page</a>.
              </Trans>
            </P>
          </P>
        </Div>
      </Section>
      <GetStarted />
    </Page>
  )
}

// Styled Components
const Div = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 664px;
  padding: 150px 0;

  h1 {
    margin-bottom: 60px;
  }
  h2 {
    text-transform: uppercase;
    margin-top: 60px;
  }
  h4 {
    margin-top: 30px;
  }
  p {
    margin-top: 15px;
  }
`

// Export.
export default DocumentationPage
export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ['common'])
  return {
    props: {
      ...translations,
    },
  }
}
